import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Form, FormControl, Row} from 'react-bootstrap';

import {SB_ENTER_KEY_CODE} from '../../Constants';
import {Conditional} from "../Conditional";
import {KeyboardUtils} from "../../Utils";
import {UPDATE_VERIFICATION_FIELD_VALUE} from "../../Redux/Actions/Types";
import {VerificationComponent} from "./VerificationComponent";
import {login} from "../../Redux/Thunks/loginThunks";

export const LoginComponent = (props) => {
    const { HideButtons, ForgotPassword } = props;
    const dispatch = useDispatch();
    const loginState = useSelector(state => state.loginState);
    
    const {isVerifying} = loginState;
    const updateField = (field, value) => {
        dispatch({type: UPDATE_VERIFICATION_FIELD_VALUE, field, value})
    };
    
    if(isVerifying) {
        return <VerificationComponent
            HideButtons={HideButtons}
        />
    }

    return (
        <Form>
            <Row key={1} className="top10">
                <Col md={3}>
                    <span className="login-form-label">Email</span>
                </Col>
                <Col md={9}>
                    <FormControl
                        autocomplete="username"
                        type="email"
                        name="email"
                        value={loginState.fields.email}
                        onChange={(e) => updateField('email', e.target.value)}
                        onKeyDown={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => dispatch(login()))}
                        autoFocus
                    />
                </Col>
            </Row>
            <Row key={2} className="top10">
                <Col md={3}>
                    <span className="login-form-label">Password</span>
                </Col>
                <Col md={9}>
                    <FormControl
                        autocomplete="current-password"
                        type="password"
                        name="password"
                        value={loginState.fields.password}
                        onChange={(e) => updateField('password', e.target.value)}
                        onKeyDown={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => dispatch(login()))}
                    />
                </Col>
            </Row>
            <Conditional Condition={!HideButtons}>
                <Row key={3} className="top10 login-btn">
                    <Col md={3} />
                    <Col md={9}>
                        <Button onClick={() => dispatch(login())} variant="primary">Login</Button>
                    </Col>
                </Row>
                <Row key={4} className="top10 forgot-password">
                    <Col md={3} />
                    <Col md={9}>
                        <a onClick={() => ForgotPassword()}>Forgot Password?</a>
                    </Col>
                </Row>
            </Conditional>
        </Form>
    );
};

